import { render } from "./CreateIsolatedNetworkForm.vue?vue&type=template&id=1d8ff488&scoped=true"
import script from "./CreateIsolatedNetworkForm.vue?vue&type=script&lang=js"
export * from "./CreateIsolatedNetworkForm.vue?vue&type=script&lang=js"

import "./CreateIsolatedNetworkForm.vue?vue&type=style&index=0&id=1d8ff488&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d8ff488"]])

export default __exports__